<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="getDataFromServer"
                >
                    Refresh Data
                </responsiveButton>
                <v-divider class="mx-6"></v-divider>
                <v-data-table
                        :headers="mainTableHeader"
                        :items="items"
                        :loading="loading"
                        loading-text="Loading... Please wait"
                        class="elevation-1"
                        :single-expand="true"
                        show-expand
                        @item-expanded="expandedEvent($event)"
                >
                    <template v-slot:item.name="{item}">
                        {{ item.name }}
                    </template>
                    <!-- Actions -->
                    <template v-slot:item.add="{item}">
                        <v-icon class="mr-4"
                                @click="addNewReport(item)"
                        >
                            mdi-plus
                        </v-icon>
                    </template>
                    <template v-slot:expanded-item="{ headers,item }">
                        <td class="px-0" :colspan="headers.length">
                            <v-row>
                                <v-col cols="11" offset="1">
                                    <data-table
                                            :headers="subTableHeader"
                                            :fetchFunction="()=>getDataInnerFunction"
                                            :tableId="selectedItem.id"
                                            ref="innerTable"
                                    >
                                        <template v-slot:item.reportRuleName="{item}">
                                            {{ item.documentFile.reportRuleName }}
                                        </template>
                                        <template v-slot:item.submitted_at="{item}">
                                            {{ item.systemCreatedDateTime|formatDate(DATE_FORMAT.LOCALE_TIME) }}
                                        </template>
                                        <template v-slot:item.status="{item}">
                                            <v-chip class="mr-4"
                                                    :color="DOCUMENT_FILE_STATUS[item.status].color"
                                                    dark>{{ DOCUMENT_FILE_STATUS[item.status].text }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.download="{item}">
                                            <file-download  :setDisabled="item.documentFile === 'NONE'"
                                                            :name="item.documentFile.name"
                                                            :belong-user-id="item.clientId"
                                                            :setIcon="true"
                                                            folder="Report"
                                            >
                                            </file-download>
                                        </template>
                                    </data-table>
                                </v-col>
                            </v-row>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <!--Report type selector modal -->
        <v-dialog v-model="dialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Please select reports to upload</v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item-group v-model="reportsSelected" multiple color="indigo">
                            <v-list-item
                                    v-for="(report, i) in reportsToSelect"
                                    :key="i"
                            >
                                <v-list-item-content>
                                    <v-list-item-title v-text="report.name"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>

                <v-card-actions>
                    <v-row no-gutters justify-center>
                        <v-col>
                            <v-btn color="default" text @click.stop="dialog=false">Cancel</v-btn>
                            <v-btn color="primary" @click.stop="uploadReports">Next</v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    const FileDownload = () => import ( '@/fileHandler/components/FileDownload');
    import DataTable from '@/components/common/DataTable';
    import {reportSelectorMixin} from "@/shared/mixins/ReportSelectorMixin";
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {USER_TYPE} from "@/shared/enums/UserType";

    export default {
        name: "ReportEmployeeUploadTable",
        props:["id", "type"],
        mixins:[reportSelectorMixin],
        components:{responsiveButton, FileDownload, DataTable},
        data(){
            return{
                subTableHeader:[
                    {   text: 'Report Name',
                        value:'reportRuleName',
                        align: 'left',
                    },
                    {   text: 'Report Status',
                        value:'status',
                        align: 'center',
                    },
                    {   text: 'Submitted At',
                        value:'submitted_at',
                        align: 'center',
                        divider: true
                    },
                    {
                      text: 'Download',
                      value: 'download',
                      align: 'center'
                    }
                ]
            }
        },
        computed:{
            mainTableHeader(){
               return [
                    {
                        text: '',
                        value: 'data-table-expand'
                    },
                    {   text: 'Client Name',
                        value:'name',
                        align: 'left',
                    },
                    {   text: 'Add',
                        value:'add',
                        align: 'center',
                        sortable: false,
                        width: '2%'
                    },
                ];
            },
        },
        methods:{
            async getDataFromServer()
            {
                this.loading = true;

                try{
                    await this.$store.dispatch('getEmployee',{id:this.path_id});
                    this.employee = this.$store.getters.getEmployee;

                    for(let client in this.employee.clients)
                    {
                        this.items.push({clientId:client, ...this.employee.clients[client]});
                    }
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }

                this.loading = false;
            },
            async getEntityData()
            {
                try{
                    await this.$store.dispatch('getClient', {id: (this.path_type.toUpperCase() === USER_TYPE.CLIENT ? this.path_id : this.entitySelectedId )});
                    await this.$store.dispatch('getEmployee', {id: (this.path_type.toUpperCase() === USER_TYPE.CLIENT ? this.entitySelectedId : this.path_id)});
                    this.client = this.$store.getters.getClient;
                    this.employee = this.$store.getters.getEmployee;
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                this.getEntityGroupType(this.client.typeID);
            },
            async getDataInnerFunction(paramsArg){
                let params = {...paramsArg}
                params.clientId=  this.selectedItem.id;
                params.employeeId = this.path_id;

                let data = {};
                try {
                    await this.$store.dispatch('getReportTable',params);
                    data.items = this.$store.getters.getReportTable;
                    if(data.items == null){
                        throw  {message: 'Not data available!'};
                    }
                }
                catch (e) {
                    this.$log.debug('Error getting report for clientID {], reportId {}, Error {}', params.clientId,
                        params.reportId, e);
                    throw e;
                }

                if(this.$store.getters.getReportsLastEvaluatedKey != null){
                    data.lastEvaluatedKey = this.$store.getters.getReportsLastEvaluatedKey;
                }

                return data;
            },
            uploadReports(){
                let reports = [];

                for(let index in this.reportsSelected)
                {
                    reports.push(this.reportsToSelect[this.reportsSelected[index]].id);
                }

                this.$router.push({name: 'employeeDetailsReportsAdd', params:{ entity_id: this.entitySelectedId }, query:{redirect:'employeeDetailsReports',reports: reports}});
            },
            addNewReport(item){
                this.entitySelectedId = item.clientId;

                if(!this.reportsToSelect.length)
                    this.getEntityData();

                this.dialog = true;
            },
        },
        async created(){
            await this.getDataFromServer();
        }
    }
</script>

<style scoped>

</style>